module.exports = __webpack_public_path__ + "img/college_icon4.b3c53c2.png";